import { contactListService } from 'config/service';
import { IFeatureFlagrResponse } from 'services/featureFlagr';
import ContactListFeatures from './types';

export const checkContactListAccess = (feat: ContactListFeatures): Promise<IFeatureFlagrResponse> =>
  contactListService.get(`/check-feature-access`, {
    params: {
      feat,
    },
  });
